import { useContext } from "react";
import { NavigationContext } from "../components/navigation";

export const useNavigation = () => {
  return useContext(NavigationContext)!;
};
